import { useTranslation } from "react-i18next";
import { RATING_BADGE_CONFIG, getOrgLogo } from "@/shared/consts";
import { useAuth } from "@/shared/hooks";

interface Props {
  clickable?: boolean;
  onClick?: () => void;
}

export default function OrganizationCard({ clickable, onClick }: Props) {
  const { t } = useTranslation("Sidebar");
  const { user } = useAuth();
  const data = user?.organization;

  if (!data) return null;

  const badge = RATING_BADGE_CONFIG[data.rating_badge];
  const badgeLabel = badge ? t(badge.labelKey) : "";
  const orgLogo = getOrgLogo(data.rating_badge);
  const orgLogoLabel = t(orgLogo.labelKey);

  const cardContent = (
    <div className="flex items-center gap-3 p-2 surface-base-fill input-box-shadow radius-sm">
      <img src={orgLogo.image} alt={orgLogoLabel} title={orgLogoLabel} className="w-10 h-10 shrink-0 object-contain" />

      <div className="min-w-0 flex-1">
        <p className="truncate text-label-sm content-base-primary">{data.name}</p>
        {data.bin && (
          <p className="text-body-regular-xs content-base-low">{t("organizationCard.bin", { bin: data.bin })}</p>
        )}
      </div>

      {badge && <img src={badge.image} alt={badgeLabel} title={badgeLabel} className="w-10 h-10 shrink-0" />}
    </div>
  );

  return (
    <div className="pb-2 pt-1">
      <p className="mb-1.5 text-body-regular-xs content-base-primary">{t("myOrganization")}</p>

      {clickable ? (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          className="w-full text-left cursor-pointer">
          {cardContent}
        </button>
      ) : (
        cardContent
      )}
    </div>
  );
}

